import { IonButton } from '@ionic/react';
import { useInstance } from '../support/ioc/useInstance';
import { AlertPresenter } from '../app/AlertBinder.tsx';

export const DeleteAttachment: React.FC<{ onDelete:() => void; }> = ({ onDelete }) => {
    const alert = useInstance(AlertPresenter);

    const deleteAttachment = async () => {
        const destroyOrCancel = await alert.confirmDestructiveAction({
            header: 'Delete Attachment?',
            message: 'This file will be deleted and cannot be recovered.'
        });

        if (destroyOrCancel === 'destroy'){
            onDelete();
        }
    };

    return (
        <IonButton
            fill="clear"
            size="small"
            onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                deleteAttachment();
            }}
            data-type="delete-attachment-button"
        >
            Delete
        </IonButton>
    );
};
